<div class="inline-plan">
  <div class="inline-plan__header">
    <mat-icon class="inline-plan__header-icon">map</mat-icon>
    <span class="inline-plan__title">Plan — awaiting approval</span>
    <span class="inline-plan__status" aria-hidden="true">
      <span class="step-dots">
        <span class="step-dot"></span><span class="step-dot"></span><span class="step-dot"></span>
      </span>
    </span>
  </div>

  @if (plan().Output) {
    <p class="inline-plan__output">{{ plan().Output }}</p>
  }

  @if (isEditing()) {
    <mat-form-field appearance="outline" class="inline-plan__textarea-field">
      <textarea
        matInput
        rows="12"
        placeholder="Edit the plan..."
        [value]="draftPlan()"
        (input)="onDraftInput($event)"
        [disabled]="currentAction() !== null"
      ></textarea>
    </mat-form-field>
  } @else if (draftPlan()) {
    <div class="inline-plan__body" [innerHTML]="draftPlan() | glxyMarkdown"></div>
  }

  <div class="inline-plan__actions">
    <div class="inline-plan__actions-left">
      @if (isEditing()) {
        <button
          mat-button
          type="button"
          [disabled]="currentAction() !== null"
          (click)="onCancelEditing()"
        >
          Cancel Edit
        </button>
      } @else {
        <button
          mat-button
          type="button"
          [disabled]="currentAction() !== null"
          (click)="onEdit()"
        >
          <mat-icon>edit</mat-icon>
          Edit
        </button>
      }
    </div>
    <div class="inline-plan__actions-right">
      <button
        mat-stroked-button
        class="inline-plan__cancel-btn"
        type="button"
        [disabled]="currentAction() !== null"
        (click)="onReject()"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        class="inline-plan__primary-btn"
        type="button"
        [disabled]="currentAction() !== null"
        (click)="onApprove()"
      >
        @if (isEditing()) {
          Save & Approve
        } @else {
          Approve
        }
      </button>
    </div>
  </div>
</div>
